<template>
    <div class="d-flex justify-content-center mt-10">
        <div class="mt-2 mb-10">
            <v-row>
                <v-col class="d-inline-flex">
                    <h2 style="font-size: 30px; white-space: nowrap;" class="mr-4">leaderboard hordemode</h2>
                    
                    <div v-if="events">
                        <v-select
                            :items="events"
                            :item-text="'desc'"
                            :item-value="'id'"
                            v-model="selectedEventId"
                            v-on:change="getToplist"
                            dense
                            label="Select season">
                        </v-select>
                    </div>
                </v-col>
            </v-row>
            <v-row justify-md="center">
                <v-col class="d-flex align-items-center">
                    <v-card class="pa-4 w-100">
                        <div class="d-flex align-items-center mb-2">
                            <v-select 
                                :items="tiers"
                                v-model="selectedTiers"
                                multiple
                                dense
                                label="Select tiers">
                            </v-select>
                            
                            <!-- TO DO: IMPLEMENT THESE FEATURES -->
                            <!-- <v-btn small elevation="2" class="ml-4" @click="jumpToMyData()">Focus on your score</v-btn>

                            <div class="d-flex align-items-center ml-4">
                                <small class="mr-2">Show only you and your friends</small>
                                <v-switch v-model="showOnlyFriends"></v-switch>
                            </div> -->
                        </div>

                        <v-data-table 
                            :headers="headers" 
                            :items="filteredItems"
                            :page.sync="page"
                            :items-per-page="itemsPerPageSelected"
                            group-by="tierIndex"
                            @page-count="pageCount = $event"
                            hide-default-footer
                            class="elevation-1">
                                <template v-slot:[`group.header`]="{ group, headers }">
                                    <td :colspan="headers.length">
                                        <span class="mx-4 font-weight-bold">Tier {{ group }}</span>
                                    </td>
                                </template>
                                
                                <template v-slot:item="{ item }">
                                    <tr :class="medata.id === item.user_id ? 'my-data-row' : ''">
                                        <td># {{ item.playerRank }}</td>
                                        <td>{{ item.display_name }}</td>
                                        <td>{{ item.score }}</td>
                                        <td>{{ item.metadata }}</td>
                                        <td>
                                            <v-menu left bottom>
                                                <template v-slot:activator="{ on, attrs }">
                                                    <v-btn icon v-bind="attrs" v-on="on">
                                                        <v-icon>mdi-dots-horizontal</v-icon>
                                                    </v-btn>
                                                </template>
                                                <v-list>
                                                    <v-list-item @click="reportName(item)">Report display name</v-list-item>
                                                </v-list>
                                            </v-menu>
                                        </td>
                                    </tr>
                                </template>
                        </v-data-table>

                        <div class="d-flex justify-end mt-4">
                            <v-pagination v-model="page" :length="pageCount"></v-pagination>
                            
                            <div class="flex-shrink-1 ml-4">
                                <v-select
                                    :items="itemsPerPage"
                                    v-model="itemsPerPageSelected"
                                    label="Items per page"
                                    dense
                                    solo>
                                </v-select>
                            </div>
                        </div>
                    </v-card>
                </v-col>
            </v-row>
        </div>
    </div>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
import store from "../../../store";

import { events } from "../../../store/modules/events";
import { account } from "../../../store/modules/account";

if (!store.state.events) store.registerModule("events", events);
if (!store.state.account) store.registerModule("account", account);
const { mapState } = createNamespacedHelpers("events", "account");

const userToken = localStorage.getItem('vue-authenticate.vueauth_token');

export default {
    name: "SELeaderboard",
    components: {},
    data() {
        return {
            dates: {
                end: "2021-11-01T00:00:00.000Z",
                start: "2021-10-01T00:00:00.000Z"
            },
            showOnlyFriends: false,
            page: 1,
            pageCount: 0,
            itemsPerPage: [5, 10, 50],
            itemsPerPageSelected: 5,
            tiers: [],
            selectedTiers: [],
            selectedEventId: '',
            headers: [
                {
                    text: 'Rank',
                    align: 'start',
                    value: 'rank',
                    sortable: false,
                    groupable: false
                },
                { 
                    text: 'Display Name',
                    value: 'displayName',
                    sortable: false,
                    groupable: false
                },
                { 
                    text: 'Score',
                    value: 'score',
                    groupable: false
                },
                {
                    text: 'Metadata',
                    value: 'metadata',
                    sortable: false,
                    groupable: false
                },
                {
                    text: 'Actions',
                    value: 'actions',
                    sortable: false,
                    groupable: false
                },
            ],
            players: [],
            friends: [],
            medata: {}
        }
    },
    computed: {
        ...mapState(["events"]),
        filteredItems() {
            let result;
            result = this.players;
            if (this.showOnlyFriends) {
                result = this.players.filter( player => player.isFriend );
            }
            if (this.selectedTiers.length > 0) {
                result = this.players.filter( player => this.selectedTiers.includes(player.tierIndex) );
            }

            return result
        }
    },
    created() {
        this.fetchData();
    },
    methods: {    
        fetchData() {
            this.$store.dispatch("events/fetchEvents").then(resp => {
                this.selectedEventId = resp[0].id;
                this.getToplist(this.selectedEventId);
            });
            this.$store.dispatch("account/me").then(resp => this.medata = resp);
            this.$store.dispatch("account/getAllFriends").then(resp => {
                this.friends = resp.approved_friends;
            })
        },
        getToplist(eventId) {
            this.$store.dispatch("events/getToplist", { userToken: userToken, eventId: eventId ? eventId : this.selectedEventId}).then( resp => {
                this.tiers = resp.data.tiers.map(tier => resp.data.tiers.indexOf(tier) + 1);
                
                let playersWithTiers = [];
                resp.data.tiers.forEach(tier => {
                    let tierIndex = resp.data.tiers.indexOf(tier) + 1;
                    
                    tier.map(player => {
                        player.tierIndex = tierIndex;
                        playersWithTiers.push(player);
                        
                        player.playerRank = playersWithTiers.indexOf(player) + 1;
                    })
                });
   

                this.players = playersWithTiers;
            });
        },
        paginate (val) {
            // emitted by the data-table when changing page, rows per page, or the sorted column/direction - will be also immediately emitted after the component was created
            const query = this.$route.query;
            const obj = Object.assign({}, query);
            if (val.rowsPerPage !== this.listSize[0]) obj.limit = val.rowsPerPage;
            if (val.descending) obj.desc = 'true';
            else delete obj.desc;
            obj.orderby = val.sortBy;
            obj.page = val.page;
            // check if old and new query are the same - VueRouter will not change the route if they are, so probably this is the first page loading
            let same = true;
            for (let key in query) {
                if (query[key] != obj[key]) {
                    same = false;
                    break;
                }
            }
            // to handle the case when a KEY exists in OBJ but not in query
            for (let key in obj) {
                if (query[key] != obj[key]) {
                    same = false;
                    break;
                }
            }

            if (same) this.fetchData(); // page has been manually reloaded in the browser
            
            else {
                this.$router.replace({
                    ...this.$router.currentRoute,
                    query: obj
                });
            }
        },
        jumpToMyData() {
            this.$nextTick(() => {
                let index = this.players.findIndex( player => player.displayName === "Banana Split");
                let page = Math.ceil(index / this.itemsPerPageSelected);

                this.$nextTick(() => {
                    this.page = page;
                });
            });
        },
        reportName(item) {
            this.$store
                .dispatch("account/reportDisplayName", {
                    reported_account_id: item.user_id,
                    reported_display_name: item.display_name,
                }).then(() => {
                    this.fetchData();
                }).catch(() => {
                    this.changeFriendStatusMessage = "Cannot report account";         
                });
        }
    },      
}
</script>

<style scoped>
    .my-data-row { 
        background-color: #191818;
        color:#0dd3c0;
    }
    .my-data-row:hover { background-color: #191818 !important; }
</style>